import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  AuthService,
  DataService,
  ToasterService,
} from '../../../shared/services';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BreadCrumbService } from '../../../shared/services/breadcrumb.service';

import { fromEvent, Subscription } from 'rxjs';

@Component({
  selector: 'app-fastpm-models-assistant',
  templateUrl: './assistant.component.html',
  styleUrls: ['./assistant.component.scss'],
})
export class AssistantComponent implements OnInit, OnDestroy {
  private saveModelAndTasksSub: Subscription | undefined;
  isLoading = false;

  constructor(
    private translate: TranslateService,
    private data: DataService,
    private toastr: ToasterService,
    public auth: AuthService,
    public router: Router,
    public breadCrumbService: BreadCrumbService
  ) {}

  /**
   */
  async ngOnInit(): Promise<void> {
    this.breadCrumbService.set(
      [
        {
          name: this.translate.instant('navigations.breadcrumbs.assistant'),
          link: '/assistant',
        },
      ],
      2
    );

    this.saveModelAndTasksSub = fromEvent(
      window,
      'amsyst_chatbot:generate_model_and_tasks'
    ).subscribe((event) => {
      this.saveModelAndTasks(event);
    });

    this.openAssistant();

    this.detectConversationId();
  }

  detectConversationId(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const conversationId = urlParams.get('conversationId');
    if (conversationId) {
      window.dispatchEvent(
        new CustomEvent('amsyst_chatbot:conversation_id', {
          detail: { conversation_id: conversationId },
        })
      );
    }
  }

  openAssistant(): void {
    if (!(window as any).__AMSYST_CHATBOT__) {
      return;
    }
    (window as any).__AMSYST_CHATBOT__.init({
      enabled: true,
      token: this.auth.getToken(),
      height: 'calc(100vh - 89px)',
      width: '100vw',
    });
  }

  saveModelAndTasks(event: any): void {
    const { selectedActivities, model_name } = event.detail;

    const payload = {
      model: {
        name: model_name,
        account: this.auth.getAccountId(),
        site: this.auth.getSiteId(),
      },
      tasks: selectedActivities.map((activity: any) => {
        return {
          comment: activity.guidelines,
          component: activity.component,
          criteria: '',
          description: activity.task,
          duration: 0,
          justification: activity.fmeca_link,
          keyword: '',
          procedure: '',
          tools: [],
        };
      }),
    };

    this.isLoading = true;
    this.data
      .post('api/fastpm/models/create-model-and-tasks-from-assistant', payload)
      .subscribe(
        () => {
          this.toastr.showSuccess();
          this.isLoading = false;
        },
        () => {
          this.toastr.showError();
          this.isLoading = false;
        }
      );
  }

  ngOnDestroy(): void {
    this.saveModelAndTasksSub?.unsubscribe();
    (window as any).__AMSYST_CHATBOT__?.destroy();
  }
}
